import { Button } from '@components/ui/button'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@components/ui/card'
import { InputOTP, InputOTPGroup, InputOTPSlot } from '@components/ui/input-otp'
import { useMutation } from '@connectrpc/connect-query'
import { parseErrorMessage } from '@lib/errors'
import { Loader } from 'lucide-react'
import React, { FC, FormEvent, useState } from 'react'
import { Helmet } from 'react-helmet'
import { useNavigate } from 'react-router'
import { toast } from 'sonner'
import {
  exchange,
  verifyPhoneNumberVerificationChallenge,
} from '@gen/api/v1/api-ApiService_connectquery'

const VerifyPhoneNumberView: FC = () => {
  const navigate = useNavigate()

  const exchangeMutation = useMutation(exchange)
  const verifyPhoneNumberMutation = useMutation(
    verifyPhoneNumberVerificationChallenge,
  )

  const [code, setCode] = useState<string>('')
  const [submitting, setSubmitting] = useState<boolean>(false)

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault()
    setSubmitting(true)

    try {
      // Verify the phone number
      await verifyPhoneNumberMutation.mutateAsync({
        code,
      })

      // Exchange the intermediate session for a session
      await exchangeMutation.mutateAsync({})

      setSubmitting(false)

      navigate('/')
    } catch (error) {
      setSubmitting(false)
      const message = parseErrorMessage(error)
      toast.error('Could not verify phone number', {
        description: message,
      })
    }
  }

  return (
    <>
      <Helmet>
        <title>Verify phone number | Ancho</title>
      </Helmet>

      <Card className="max-w-sm">
        <CardHeader>
          <CardTitle>Verify phone number</CardTitle>
          <CardDescription>
            An verification code has been sent to [phone placeholder]. Please
            enter the code below.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form
            className="w-full flex flex-col items-center [&>button]:mt-2"
            onSubmit={handleSubmit}
          >
            <InputOTP maxLength={6} onChange={setCode}>
              <InputOTPGroup>
                <InputOTPSlot index={0} />
                <InputOTPSlot index={1} />
                <InputOTPSlot index={2} />
                <InputOTPSlot index={3} />
                <InputOTPSlot index={4} />
                <InputOTPSlot index={5} />
              </InputOTPGroup>
            </InputOTP>

            <Button disabled={code.length < 6 || submitting} type="submit">
              {submitting && <Loader />}
              Continue
            </Button>
          </form>
        </CardContent>
      </Card>
    </>
  )
}

export default VerifyPhoneNumberView
